// extracted by mini-css-extract-plugin
export var colorSquare = "_u1-0";
export var danger = "_u1-5";
export var lightPink = "_u1-8";
export var neutralBlue = "_u1-7";
export var neutralYellow = "_u1-6";
export var normal = "_u1-1";
export var primary = "_u1-2";
export var primaryLight = "_u1-3";
export var solidBlack = "_u1-g";
export var solidGreen = "_u1-b";
export var solidLightBlue = "_u1-d";
export var solidNavy = "_u1-c";
export var solidOrange = "_u1-f";
export var solidPink = "_u1-e";
export var solidRed = "_u1-9";
export var solidYellow = "_u1-a";
export var success = "_u1-4";